export const resolveThemeMode = (
  enableDarkModeSignup: boolean | undefined,
  appMode: string | undefined
): 'light' | 'dark' => {
  if (!enableDarkModeSignup) {
    return 'light'
  }

  if (appMode === 'dark') {
    return 'dark'
  }

  return 'light'
}
